<template>
	<div class="frame">
		<iframe
			class="iframe"
			:src="getResource"
			allow="autoplay; fullscreen"
			frameBorder="0"
			@load="sendPosition()"
		></iframe>

		<div class="row q-mb-md">
			<div class="col-12" v-if="$q.platform.is.desktop">
				<q-btn
					dense
					:label="$t('check_scorm_finished')"
					icon="fal fa-redo"
					color="primary"
					class="q-mr-md"
					@click="verifyScormFinished()"
					:loading="loading"
				/>
				<q-btn
					dense
					:label="$t('cant_watch_click_here')"
					icon="fal fa-eye"
					color="primary"
					type="a"
					target="_blank"
					:href="this.activity.scorm_url"
					class="link-scorm"
				/>
			</div>

			<div class="col-12 text-center" v-if="$q.platform.is.mobile">
				<q-btn
					dense
					:label="$t('check_scorm_finished')"
					icon="fal fa-redo"
					color="primary"
					class="q-my-md"
					@click="verifyScormFinished()"
					:loading="loading"
				/>
				<q-btn
					dense
					:label="$t('cant_watch_click_here')"
					icon="fal fa-eye"
					color="primary"
					type="a"
					target="_blank"
					:href="this.activity.scorm_url"
					class="link-scorm"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'ScormPlayer',

	props: ['activity'],

	data() {
		return {
			id_course: '',
			id_trail: '',
			loading: false,
		}
	},

	computed: {
		...mapGetters({
			activities_store: 'activities/activities',
			hierarchy_order_store: 'activities/hierarchy_order',
			id_store: 'activities/id',
		}),

		getResource() {
			if (this.activity.scorm_url) {
				let source = ''

				if (this.activity.scorm_url.includes('https://django-')) {
					return this.activity.scorm_url
				} else {
					if (location.href.includes('https://www')) {
						source = this.activity.scorm_url.includes('https://www')
							? (source = this.activity.scorm_url)
							: (source = `https://www.${this.activity.scorm_url.split('https://')[1]}`)
					} else {
						source = this.activity.scorm_url.includes('https://www')
							? (source = `https://${this.activity.scorm_url.split('https://www.')[1]}`)
							: (source = this.activity.scorm_url)
					}
				}
				return source
			} else return ''
		},
	},

	methods: {
		sendPosition() {
			let fd = new FormData()
			fd.append('id_group_training_module', this.activity.type_id)

			let url = ''
			if (this.id_trail == '')
				url = `/etraining_courses/group_training/${this.id_course}/set_group_training_module_user_progress/`
			else
				url = `/etraining_trails/trail/${this.id_trail}/group_training/${this.id_course}/set_group_training_module_user_progress/`

			this.$axios
				.post(url, fd)
				.then(() => {})
				.catch((e) => {
					console.log(e)
				})
		},

		verifyScormFinished() {
			this.loading = true

			this.$axios
				.get(`/etraining_courses/group_training/${this.id_store}/get_group_training_activities/`)
				.then((response) => {
					let obj = response.data.find((obj) => obj.hierarchy_order == this.hierarchy_order_store)

					if (obj) {
						if (obj.user_watch) {
							this.updatePosition()

							this.$q.notify({
								message: this.$t('scorm_finished'),
								color: 'positive',
								icon: 'fal fa-check-circle',
							})
						} else {
							this.$q.notify({
								message: this.$t('scorm_not_finished'),
								color: 'negative',
								icon: 'fal fa-ban',
							})
						}
					}
				})
				.catch((e) => {
					console.log(e)
					if (e.response.status === 404) {
						this.$q.notify({
							message: this.$t('not_allowed_or_page_not_found'),
							type: 'negative',
							icon: 'fal fa-ban',
						})
						this.$router.push({ name: 'courses' })
					}
				})
				.finally(() => {
					this.loading = false
				})
		},

		updatePosition() {
			if (!this.activity.user_watch) {
				setTimeout(() => {
					this.$store.dispatch('activities/SET_ACTIVITY_DATA', [
						this.activity,
						{ user_watch: true },
					])
					this.$emit('finish')
				}, 500)
			}
		},
	},

	created() {
		if (this.$route.params.id_trail) this.id_trail = this.$route.params.id_trail
		if (this.$route.params.id) this.id_course = this.$route.params.id
	},
}
</script>

<style lang="scss" scoped>
.frame {
	iframe {
		width: 100%;
		height: 60vh;
	}
}
.link-scorm {
	text-decoration: none;
}
</style>
